import styled, { css } from 'styled-components'
import { borderRadius, padding, fontSize, height } from 'theme/mixins'

const Wrapper = styled.div<{ $color?: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: ${borderRadius('sm')};
	padding: ${padding('xxs')};
	font-size: ${fontSize('xl')};
	min-width: ${height('sm')};
	${({ $color }) =>
		$color &&
		css`
			color: ${$color};
		`};
`

export default { Wrapper }
